'use strict';

module.exports = '3.27.0';
